/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Stats } from '../models/Stats';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StatsService {
    /**
     * show
     * @param tenantId tenant_id
     * @returns Stats successful
     * @throws ApiError
     */
    public static getStats(
        tenantId: string,
    ): CancelablePromise<Stats> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/health_board/stats',
            path: {
                'tenant_id': tenantId,
            },
        });
    }
}
